document.addEventListener('DOMContentLoaded', () => {
    const instance = document.querySelector('[data-vue]');
    if (!instance) return;

    const initialize = () => {
        Vue.use(VueMask.VueMaskPlugin);

        const form = new Vue({
            el: instance,
            data: {
                data: {},
                lang: '',
                submitURL: '',
                submitted: false,
                state: '',
                error: false,
                yandexCaptchaId: null,
                key: '6n7g69ptsu9k76e5ig45eenudxahej6ytafcgzzy',
                listId: '1569',
                doubleOptin: '3',
                overwrite: '2'
            },
            mounted: function () {
                this.submitURL = this.$el.action;
                this.lang = document.documentElement.lang;
                this.initializeCaptcha();
            },
            methods: {
                submit: function () {
                    const data = Object.assign({}, this.data);
                    const files = this.files;
                    const formData = new FormData();

                    Object.keys(data).forEach(key => {
                        formData.append(key, data[key]);
                    });

                    if (files) {
                        formData.delete('files');

                        files.forEach((file, i) => {
                            formData.append(`files[${i}]`, file);
                        });
                    }

                    this.submitted = true;
                    this.error = false;

                    fetch(this.submitURL, {
                        method: 'POST',
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((responseData) => {
                            this.submitted = responseData.success;
                            this.error = !responseData.success;
                            this.state = responseData.state;

                            if (responseData.success) {
                                this.sendDataToUnisender();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                },

                initializeCaptcha: function () {
                    if (!window.smartCaptcha || this.yandexCaptchaId !== null) {
                        return;
                    }
                    const captchaId = 'captcha-container-' + this.$el.dataset.vue;
                    const captchaContainer = document.createElement('div');
                    captchaContainer.id = captchaId;
                    this.$el.appendChild(captchaContainer);

                    this.yandexCaptchaId = window.smartCaptcha.render(captchaId, {
                        sitekey: window.captchaPublicKey,
                        invisible: true,
                        callback: this.captchaCallback,
                        hideShield: true,
                    });
                },

                captchaCallback(token) {
                    this.data.captchaResponse = (token) ? token : '';
                    if (this.data.captchaResponse !== '') {
                        this.submit();
                    }
                },

                checkCaptcha() {
                    if (this.yandexCaptchaId !== null) {
                        window.smartCaptcha.execute(this.yandexCaptchaId);
                    }
                },

                sendDataToUnisender() {
                    fetch(`https://api.unisender.com/ru/api/subscribe?format=json&api_key=${this.key}&list_ids=${this.listId}&fields[email]=${this.data.email}&fields[phone]=${this.data.phone}&double_optin=${this.doubleOptin}&overwrite=${this.overwrite}`)
                        .then((response) => {
                            console.log(response)
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
        })
    };

    $.when(
        $.getScript("https://smartcaptcha.yandexcloud.net/captcha.js")
    ).done(function () {
        initialize();
    });
});
